import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import useBackButtonHandle from "../../../../hooks/useBackButtonHandle";
import {useHistory} from "react-router";
import {popupStatus, setAversionLayerHandler} from "../../../Layout/actions";
import LossAversionLayer from "./widget/LossAversionLayer";
import {RootStore} from "../../../../configureStore";
import config from "../../../../config/config";

const LossAversionLayerWrapper: React.FC = () => {
    const [showAversionLayer, setShowAversionLayer] = useState(false);
    const popupName = "lossAversionWrapper";
    const isUserInteracted = useSelector((state: RootStore) => state.layout.isUserInteracted);

    const dispatch = useDispatch();
    const history = useHistory();

    // Activate Loss Aversion Layer on Page
    useEffect(() => {
        dispatch(setAversionLayerHandler({aversionLayerHandler: true}));
        return () => {
            dispatch(setAversionLayerHandler({aversionLayerHandler: false}));
        };
    }, [dispatch]);

    // On before unload => refresh and cancel button
    useEffect(() => {
        if (isUserInteracted) {
            const handleDefault = (e: BeforeUnloadEvent) => {
                e.preventDefault();
                e.returnValue = "";
            };
            window.onbeforeunload = handleDefault;
            return () => {
                window.onbeforeunload = null;
            };
        }
    }, [isUserInteracted]);

    // Back Button Handling on Registration Page
    const [click, setClick] = useState(false);
    useEffect(() => {
        const clickEvent = () => {
            setClick(true);
        };
        window.addEventListener("click", clickEvent);
        window.addEventListener("touchstart", clickEvent);
        return () => {
            window.removeEventListener("click", clickEvent);
            window.removeEventListener("touchstart", clickEvent);
        };
    }, []);

    useEffect(() => {
        if (click) {
            const {pathname, search} = window.location;
            history.push(`${pathname}${search}`, {popup: popupName});
            dispatch(popupStatus({action: "add", name: popupName}));
        }
        return () => {
            if (click) {
                dispatch(popupStatus({action: "remove", name: popupName}));
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [click, dispatch]);

    useBackButtonHandle({
        name: popupName,
        preventDefaultBack: true,
        closeHandle: () => setShowAversionLayer(true),
        isActive: click,
        disableBack: true,
        appendHash: false,
    });

    const referrerURL = useSelector((state: RootStore) => state.layout.referrerURL);
    const isReferrerPWA = useSelector((state: RootStore) => state.layout.isReferrerPWA);
    const exitAversionLayer = useCallback(() => {
        setShowAversionLayer(false);
        if (referrerURL) {
            if (isReferrerPWA) {
                history.push(referrerURL);
            } else {
                window.location.href = referrerURL;
            }
            return;
        }
        window.location.href = config.SHIKSHA_STUDYABROAD_HOME;
    }, [history, isReferrerPWA, referrerURL]);

    return useMemo(() => {
        if (showAversionLayer) {
            return (
                <LossAversionLayer
                    showAversionLayer={showAversionLayer}
                    exitAversionLayer={exitAversionLayer}
                    closeOnlyAversionLayer={() => setShowAversionLayer(false)}
                />
            );
        }
        return null;
    }, [showAversionLayer, exitAversionLayer]);
};

export default LossAversionLayerWrapper;
